import script from "./EmailInput.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailInput.vue?vue&type=script&setup=true&lang=js"

import "./EmailInput.vue?vue&type=style&index=0&id=eab794c0&lang=css"

const __exports__ = script;

export default __exports__